/** the main data attribute key to add to basic components */
export const DATA_TEST_ID = "data-testid";

/** to be used for all spinner/skeleton and loading component */
export const DATA_TEST_ID_LOADER = "loader";

export const DATA_TEST_ID_SCROLL = "scroll";
export const DATA_TEST_ID_BUTTON = "button";
export const DATA_TEST_ID_ICON_BUTTON = "icon-button";
export const DATA_TEST_ID_INPUT = "input";
export const DATA_TEST_ID_CHIP = "chip";
export const DATA_TEST_ID_BADGE = "badge";
export const DATA_TEST_ID_ICON = "icon";
export const DATA_TEST_ID_TAB = "tab";
export const DATA_TEST_ID_MODAL = "modal";
export const DATA_TEST_ID_ACCORDION = "accordion";
export const DATA_TEST_ID_AVATAR = "avatar";
export const DATA_TEST_ID_CHECKBOX = "checkbox";
export const DATA_TEST_ID_LINK = "link";
export const DATA_TEST_ID_SELECT = "select";
export const DATA_TEST_ID_DROPDOWN = "dropdown";
export const DATA_TEST_ID_SWITCH = "switch";
export const DATA_TEST_ID_IMAGE = "image";
export const DATA_TEST_ID_SLIDER = "slider";
export const DATA_TEST_ID_CONTAINER_CLICKABLE = "container-clickable";
export const DATA_TEST_ID_TEXTAREA = "textarea";
export const DATA_TEST_ID_RADIO = "radio";
export const DATA_TEST_ID_TOOLTIP = "tooltip";
export const DATA_TEST_ID_DIVIDER = "divider";
export const DATA_TEST_ID_TOAST = "toast";

export const DATA_TEST_ID_TABLE = "table";
export const DATA_TEST_ID_TABLE_HEADER = "table-header";
export const DATA_TEST_ID_TABLE_COLUMN = "table-column";
export const DATA_TEST_ID_TABLE_CELL = "table-cell";
export const DATA_TEST_ID_TABLE_BODY = "table-body";
export const DATA_TEST_ID_TABLE_ROW = "table-row";
export const DATA_TEST_ID_LISTBOX = "listbox";
